// extracted by mini-css-extract-plugin
module.exports = {"googleBtn":"GoogleAuth_googleBtn__Ez-MJ","googleContainer":"GoogleAuth_googleContainer__1lViu"};